var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { ModalTitle } from 'root/src/client/v2/common/components/modal/ModalTitle';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import Switch from '@material-ui/core/Switch';
import { trpc } from 'root/src/client/v2/trpc/trpc';
const CreatorSettingsItem = ({ title, description, control, isLoading }) => (<label className="flex items-center cursor-pointer select-none justify-between gap-4 py-3 border-b border-white/10 last:border-b-0">
		<div className="flex flex-col min-w-0">
			<span className="text-white font-bold">{title}</span>
			<span className="text-white/60 text-sm">{description}</span>
		</div>
		<div className="flex-shrink-0">
			{isLoading ? <div className="w-14 h-6 rounded-full bg-gradient-to-bl from-light-4 to-light-5 animate-pulse"/> : control}
		</div>
	</label>);
const HideLiveStreamPlayerSetting = () => {
    var _a;
    const trpcUtils = trpc.useUtils();
    const { data, isLoading } = trpc.creators.getCreatorSettings.useQuery();
    const toggleLiveStreamPlayerMutation = trpc.creators.toggleLiveStreamPlayer.useMutation({
        onSuccess: () => __awaiter(void 0, void 0, void 0, function* () {
            yield Promise.all([
                trpcUtils.creators.getCreatorSettings.invalidate(),
                trpcUtils.creators.getCreatorLiveStream.invalidate(),
            ]);
        }),
    });
    const isHidden = (_a = data === null || data === void 0 ? void 0 : data.hideLiveStreamPlayer) !== null && _a !== void 0 ? _a : false;
    return (<CreatorSettingsItem title="Hide my live streams" description="When enabled, the floating Twitch player will not be shown to viewers on your profile. You will still see it yourself." isLoading={isLoading} control={(<Switch defaultChecked={isHidden} onChange={(_, next) => toggleLiveStreamPlayerMutation.mutate({ enable: !next })}/>)}/>);
};
export const CreatorSettingsModal = () => {
    const modal = useModal();
    return (<ModalLayout>
			<ModalTitle>Settings</ModalTitle>
			<div className="flex flex-col w-full sm:min-w-[420px]">
				<HideLiveStreamPlayerSetting />
			</div>
			<ButtonNew onClick={() => modal.hide()}>Close</ButtonNew>
		</ModalLayout>);
};
